<section class="lp-section" [class.lp-section--last]="last" [class.store-rail--locked]="lockColumns">
  <div class="lp-rail-head">
    <h2 class="lp-h2">
      {{ rail.titleLead }} <span class="gold">{{ rail.titleGold }}</span>
      <span class="lp-rail-genre" *ngIf="rail.kind === 'map' && rail.genreLabel">{{ rail.genreLabel }}</span>
    </h2>
    <a class="lp-see-all" [routerLink]="['/store']" [queryParams]="rail.seeAllParams">See all</a>
  </div>
  <p class="lp-section-sub" *ngIf="rail.subtitle">{{ rail.subtitle }}</p>

  <div class="tile-grid" [ngClass]="'tile-grid--' + rail.density">
    <article
      class="content-tile flip-card"
      *ngFor="let item of rail.items; trackBy: trackItem"
      [class.is-flipped]="isFlipped(rail.id + ':' + item.id)"
      tabindex="0"
      role="link"
      [attr.aria-label]="item.title"
      (click)="onStoreTileActivate(item, $event)"
      (keydown)="onStoreTileKey(item, $event)"
    >
      <span class="flip-inner">
        <span class="flip-face flip-front">
          <span class="content-tile-img" [style.background-image]="'url(' + item.image + ')'">
            <span class="tile-img-chip" *ngIf="showSystemChip(rail.density)">{{ item.gamesystem }}</span>
          </span>
        </span>
        <span class="flip-face flip-back">
          <span class="tile-back-tags" *ngIf="showHoverType(rail.density)">
            <span class="chip chip-type">{{ shortType(item.type) }}</span>
          </span>
          <span
            *ngIf="showHoverDesc(rail.density)"
            #pitchBox
            class="tile-back-desc"
            [class.tile-back-desc--marquee]="showPitchMarquee(rail.density)"
            [style.--pitch-duration]="pitchDuration(item.desc)"
          >
            <ng-container *ngIf="showPitchMarquee(rail.density); else staticPitch">
              <span class="tile-back-pitch-track">
                <span class="tile-back-pitch">{{ item.desc }}</span>
                <span class="tile-back-pitch" aria-hidden="true">{{ item.desc }}</span>
              </span>
            </ng-container>
            <ng-template #staticPitch>{{ item.desc }}</ng-template>
          </span>
          <span class="tile-back-author" *ngIf="showHoverAuthor(rail.density)">
            Author:
            <a
              class="tile-author-link"
              [routerLink]="['/store']"
              [queryParams]="authorStoreParams(item)"
              (click)="$event.stopPropagation()"
            >{{ item.author }}</a>
          </span>
        </span>
      </span>
      <ng-container [ngTemplateOutlet]="storeCaption" [ngTemplateOutletContext]="{ item: item, density: rail.density }"></ng-container>
    </article>

    <a
      class="create-tile"
      *ngFor="let _ of rail.createPlaceholders"
      [routerLink]="createCommands().path"
      [queryParams]="createCommands().query"
    >
      <span class="create-tile-art">
        <span class="create-tile-plus" aria-hidden="true">+</span>
      </span>
      <span class="create-tile-copy">
        <span class="create-tile-label">Create</span>
        <span class="create-tile-sub">Don’t see it? Make one.</span>
      </span>
    </a>
  </div>
</section>

<ng-template #storeCaption let-item="item" let-density="density">
  <span class="tile-caption">
    <span class="content-tile-name">{{ item.title }}</span>
    <span class="tile-caption-details" *ngIf="showStorePlayStats(density)">
      <ng-container *ngIf="density === 5; else widePlayStats">{{ storeCaptionMeta(item) }}</ng-container>
      <ng-template #widePlayStats>
        <span>{{ storePlaytime(item) }}</span>
        <span *ngIf="storePlayers(item) as players">{{ players }}</span>
        <span *ngIf="storeLevel(item) as level">{{ level }}</span>
      </ng-template>
    </span>
    <span class="tile-caption-system" *ngIf="showCaptionSystem(density)">{{ item.gamesystem }}</span>
    <span class="tile-caption-meta">
      <span class="tile-rating-cluster">
        <span class="tile-stars" role="img" [attr.aria-label]="ratingLabel(item)">
          <span
            class="tile-star"
            *ngFor="let i of starIndexes"
            [ngClass]="'is-' + starFill(item.rating, i)"
            aria-hidden="true"
          >
            <svg class="tile-star-base" viewBox="0 0 24 24"><path d="M12 2.6 14.7 8.8l6.8.9-5 4.8 1.3 6.7L12 18.2l-5.8 3-1.3-6.7-5-4.8 6.8-.9L12 2.6z"/></svg>
            <svg class="tile-star-fill" viewBox="0 0 24 24"><path d="M12 2.6 14.7 8.8l6.8.9-5 4.8 1.3 6.7L12 18.2l-5.8 3-1.3-6.7-5-4.8 6.8-.9L12 2.6z"/></svg>
          </span>
        </span>
        <span class="tile-review-count" *ngIf="showReviewCount(density)">({{ item.reviews }})</span>
      </span>
      <span class="tile-price">{{ storePrice(item) }}</span>
      <span class="tile-caption-author" *ngIf="density === 2">
        Author:
        <a
          class="tile-author-link"
          [routerLink]="['/store']"
          [queryParams]="authorStoreParams(item)"
          (click)="$event.stopPropagation()"
        >{{ item.author }}</a>
      </span>
    </span>
  </span>
</ng-template>
